import * as yup from 'yup';
import { setLocale } from 'yup';
import i18n from '@/libs/i18n/client';

// Messages must be lazy functions: `setLocale` runs at module-load, before i18n has finished
// initializing, so calling `i18n.t()` eagerly captured the literal key (e.g. "str.required") and it
// leaked to the UI. Functions are evaluated at validation time, once translations are ready.
setLocale({
    mixed: {
        required: () => i18n.t('str.required'),
    },
    string: {
        email: () => i18n.t('str.email.invalid'),
    },
    array: {
        min: () => i18n.t('str.required'),
        max: ({ max }) => i18n.t('str.validate.array.max', { count: max }),
    },
});

export default yup;
